import React from "react";
import { Outlet } from "react-router-dom";

import WrapperContainer from "../components/WrapperContainer/WrapperContainer.jsx";

/**
 * Обёртка для страниц мобильного подключения услуг
 */
const MobileConnectionBase = () => {
  return (
    <div className="layout">
      <div className="main">
        <div className="wrapper">
          <div className="mobile-connection">
            <div>
              <WrapperContainer align="center">
                <img
                  src={require("../assets/img/logo-ufanet.svg").default}
                  className="logo-company"
                  alt=""
                />
              </WrapperContainer>

              <div className="forms-container">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileConnectionBase;
